<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <h3>Passwort ändern</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newProviderForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6 form-div">
                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Current password is required.',
                    }"
                  >
                    <div class="password-input-div">
                      <v-text-field
                        :type="show === true ? 'text' : 'password'"
                        autocomplete="new-password"
                        v-model="form.oldPassword"
                        :error-messages="errors[0]"
                        label="Aktuelles Passwort"
                        outlined
                      ></v-text-field>
                      <i
                        class="fas fa-eye show-icon"
                        v-if="show"
                        @click="show = !show"
                      ></i>
                      <i
                        class="fas fa-eye-slash show-icon"
                        v-else
                        @click="show = !show"
                      ></i>
                    </div>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    name="Password"
                    vid="password"
                    rules="required|passwordInput"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'New password is required.',
                    }"
                  >
                    <div class="password-input-div">
                      <v-text-field
                        :type="show2 === true ? 'text' : 'password'"
                        autocomplete="new-password"
                        v-model="form.newPassword"
                        :error-messages="errors[0]"
                        label="Neues Passwort"
                        @input="passwordCheck"
                        outlined
                      ></v-text-field>
                      <i
                        class="fas fa-eye show-icon"
                        v-if="show2"
                        @click="show2 = !show2"
                      ></i>
                      <i
                        class="fas fa-eye-slash show-icon"
                        v-else
                        @click="show2 = !show2"
                      ></i>
                    </div>
                    <div
                      v-if="form.newPassword"
                      class="row password-strength mt-3"
                    >
                      <div class="col-md-10 p-0">
                        <v-progress-linear
                          :value="progressValue"
                          :color="progressColor"
                        ></v-progress-linear>
                      </div>
                      <div class="col-md-2 pr-0 text-right">
                        <span>{{ passwordStrength }}</span>
                      </div>
                    </div>
                    <span class="note-text text-secondary"
                      >Das Passwort muss mindestens 8 Zeichen, sowie eine
                      Kombination von Sonderzeichen, Zahlen, Groß- und
                      Kleinbuchstaben enthalten.</span
                    >
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    name="Password confirmation"
                    rules="required|confirmed:password"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Please confirm new password.',
                    }"
                  >
                    <div class="password-input-div">
                      <v-text-field
                        name="password"
                        :type="show3 === true ? 'text' : 'password'"
                        autocomplete="new-password"
                        v-model="form.confirmPassword"
                        :error-messages="errors[0]"
                        label="Passwort bestätigen"
                        outlined
                      ></v-text-field>
                      <i
                        class="fas fa-eye show-icon"
                        v-if="show3"
                        @click="show3 = !show3"
                      ></i>
                      <i
                        class="fas fa-eye-slash show-icon"
                        v-else
                        @click="show3 = !show3"
                      ></i>
                    </div>
                  </ValidationProvider>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                  <!-- <br />
              <span class="form-errors" v-if="formError"
                >One or more fields has error. Please check form again.</span
              > -->
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="admin" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import VueTelInput from "vue-tel-input";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import { LOGIN, UPDATE_USER } from "@/core/services/store/auth.module";
import { extend } from "vee-validate";

Vue.use(Croppa, { componentName: "my-image-cropper" });

Vue.use(VueTelInput);
Vue.use(Notifications);

extend("passwordInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+,.\\\/;':"-]).{8,}$/;
    var validPassword = regx.test(value);
    if (validPassword) {
      return true;
    } else {
      false;
    }
  },
});

export default {
  name: "EditProfile",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    }
  },
  data() {
    return {
      formError: false,
      userId: null,
      btnDisable: false,
      submitText: "Abschicken",
      show: false,
      show2: false,
      show3: false,
      isPoor: false,
      isGood: false,
      isStrong: false,
      passwordStrength: "Poor",
      contains_lovercase: false,
      contains_number: false,
      contains_uppercase: false,
      containSpecialChar: false,
      progressValue: 0,
      progressColor: "error",
      countryDialCode: "",
      form: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
      },
    };
  },
  methods: {
    passwordCheck(val) {
      this.contains_lovercase = /[a-z]/.test(this.form.newPassword);
      this.contains_number = /\d/.test(this.form.newPassword);
      this.contains_uppercase = /[A-Z]/.test(this.form.newPassword);
      this.containSpecialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(
        this.form.newPassword
      );

      if (
        this.form.newPassword.length > 0 &&
        this.form.newPassword.length <= 8
      ) {
        this.isPoor = true;
        this.passwordStrength = "Poor";
        this.progressValue = 33;
        this.progressColor = "error";
      } else {
        this.isPoor = false;
      }
      if (this.form.newPassword.length > 8) {
        this.isGood = true;
        this.passwordStrength = "Good";
        this.progressValue = 66;
        this.progressColor = "yellow darken-2";
      } else {
        this.isGood = false;
      }
      if (
        this.form.newPassword.length > 8 &&
        this.contains_lovercase &&
        this.contains_number &&
        this.contains_uppercase &&
        this.containSpecialChar
      ) {
        this.isStrong = true;
        this.passwordStrength = "Strong";
        this.progressValue = 100;
        this.progressColor = "green";
      } else {
        this.isStrong = false;
      }
    },
    goToBack() {
      this.$router.push({ name: "admin-dashboard" });
    },
    onSubmit() {
      this.$refs.newProviderForm.validate().then((success) => {
        if (success) {
          this.formError = false;
          this.btnDisable = true;
          this.submitText = "Wird abgeschickt...";

          localStorage.setItem("currentProviderCountry", this.form.country);
          let formData = new FormData();

          formData.append("user_id", this.$route.params.id);
          formData.append("old_password", this.form.oldPassword);
          formData.append("new_password", this.form.newPassword);

          setTimeout(() => {
            axios
              .request({
                method: "POST",
                url: "change-password",
                mimeType: "multipart/form-data",
                data: formData,
              })
              .then((response) => {
                if (response.data.status == "success") {
                  this.$notify({
                    group: "admin",
                    type: "success",
                    position: "bottom right",
                    text: response.data.message,
                    duration: 5000,
                  });
                  this.btnDisable = false;
                  setTimeout(() => {
                    this.$router.push({ name: "admin-dashboard" });
                  }, 3000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Abschicken";
                  this.$notify({
                    group: "admin",
                    type: "error",
                    position: "bottom right",
                    text: response.data.message,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Abschicken";
                this.$notify({
                  group: "admin",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Abschicken";
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.croppa-container svg.icon-remove {
  top: 0 !important;
  right: unset !important;
  left: 0 !important;
}

.profile-initial-pic {
  position: relative;
}

.remove-btn {
  position: absolute;
  top: -5px;
  cursor: pointer;
}

.show-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.strendth-div {
  border: 1px solid lightgrey;
  height: 7px;
  margin: 2px;
  border-radius: 10px;
}

.red {
  background-color: red;
}

.orange {
  background-color: orange;
}

.green {
  background-color: green;
}
.password-input-div {
  position: relative;
}
.note-text {
  font-size: 12px;
  color: grey;
}
</style>
